import React, { Fragment } from 'react';
import { Outlet } from 'react-router-dom';


const AuthenticationPage = () => {
  return (
    <Fragment>
      <div>
        <div>
          <Outlet />
        </div>
      </div>
    </Fragment>
  )
};
export default AuthenticationPage;